import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsAndConditions from "@/pages/TermsAndConditions";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsAndConditions />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                theme="dark"
                richColors
                toastOptions={{
                    style: {
                        background: "#0A0A0A",
                        color: "#F4F0E6",
                        border: "1px solid rgba(201,162,39,0.35)",
                        fontFamily: "Manrope, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
